<template>
  <v-container class="unknown-user">
    <h1 class="unknown-user__title">Hello {{ name }}.</h1>
    <small><button @click.prevent="logout">Logout</button></small>
    <p>
      Awesome you are registered and we appreciate you!
    </p>
    <p>  
      Please let management know you completed the registration so we can configure your account with the necessary permissions.
    </p>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'uknownUser',
  data: () => {
    return {
      name: undefined
    }
  },
  computed: {
    ...mapGetters({
      userName: 'user/getUserName'
    })
  },
  methods: {
    logout () {
      this.$store.dispatch('user/logout')
    }
  },
  mounted () {
    this.name = this.userName
    setTimeout(() => {
      this.$store.dispatch('user/logout', true)
    }, 3000)
  }
}
</script>

<style lang="scss">
.unknown-user {
  &__title {
    margin-bottom: 25px;
  }
}
</style>
